export const regularFeaturesContent = [
  {
    text: "- Standard Design",
    badge: false
  },
  {
    text: "- No Avatar",
    badge: false
  },
  {
    text: "- Regular support",
    badge: false
  }
]